export default __webpack_public_path__ + "static/media/redgram.e5c65ac5.png";